/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { customFieldDataLocationSchema } from './CustomFieldDataLocationSchema'
import { customFieldDataTypeSchema } from './CustomFieldDataTypeSchema'

export const customFieldDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	type: customFieldDataTypeSchema,
	location: customFieldDataLocationSchema,
	isRequired: z.boolean(),
})

export type CustomFieldDataSchema = z.infer<typeof customFieldDataSchema>
